/*
* @描述: 报价单列表
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/24 09:46
*/
<template>
    <PullContainer ref="pullContainerRef" :pullDownLabel="true" :pullDownLoading="false">
        <template #container>
            <div v-loading="loading" class="public_container">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="true" :isTitleNormal="true" title="返回">

                    </ReturnNavBar>
                </div>
                <div class="mobile_container index_statistics_wrap">

                </div>
                <FooterTabbar :tabBarActive="tabBarActive" :tabBarList="tabBarList"></FooterTabbar>
            </div>
        </template>
    </PullContainer>
</template>
<script>
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";

export default {
    name: "Business",
    data() {
        return {
            loading: false,
            tabBarList: [
                {
                    icon: "icon-shangji1",
                    activeIcon: "icon-shangjixuanzhong",
                    routerName: "Business",
                    title: "商机",
                },
                {
                    icon: "icon-baojiadan1",
                    activeIcon: "icon-baojiadanxuanzhong",
                    routerName: "Quotation",
                    title: "报价",
                },
            ],
            tabBarActive: 1,
        }
    },
    components: {
        PullContainer,
        ReturnNavBar,
        FooterTabbar
    },
    created() {

    },
    computed: {},
    mounted() {

    },
    methods: {

    },
}
</script>
<style lang="scss" scoped>
.index_statistics_wrap {
    padding: 10px 16px;

    .order_statistics_wrap {
        margin-bottom: 10px;
        padding: 12px;
        width: 100%;
        height: 142px;
        border-radius: 4px;
        background: url("https://download.hecoos.com/enlightv/2025-10/4f9df466c1d4df89afafec128b6b8d7c.png") no-repeat;
        background-size: 100% 100%;

        .total_orders_wrap {
            width: calc(50% - 5px);
            height: 86px;
            padding: 8px;
            border-radius: 6px;
            margin-top: 8px;
            background: url("https://download.hecoos.com/enlightv/2025-10/a9520046392f3fe767df80655bb7ac95.png") no-repeat;
            background-size: 100% 100%;
        }

        .total_amount_wrap {
            width: calc(50% - 5px);
            height: 86px;
            padding: 8px;
            border-radius: 6px;
            margin-top: 8px;
            background: url("https://download.hecoos.com/enlightv/2025-10/61452d90803762a36faa88bd781fbd78.png") no-repeat;
            background-size: 100% 100%;
        }

        .title {
            font-size: 12px;
            font-weight: 700;
            line-height: 18px;
            color: #333333;
            margin-bottom: 6px;
        }

        .total_num {
            font-size: 18px;
            font-weight: 700;
            line-height: 26px;
            color: #2990FF;
        }

        .yesterday_text {
            font-size: 12px;
            line-height: 18px;
            color: #666666;
            margin-top: 2px;
        }

        .icon-xiajiang {
            color: #5AB333;
            margin-left: 2px;
        }

        .icon-shangsheng {
            color: #E44144;
            margin-left: 2px;
        }
    }

    .other_statistics_wrap {
        min-height: calc(100% - 215px);
        margin-top: 63px;
        background: linear-gradient(180deg, rgba(255, 242, 243, 1) 0%, rgba(255, 255, 255, 1) 100%);
        position: relative;
        padding-top: 63px;

        .statistics_data_wrap {
            width: 100%;
            position: absolute;
            top: -52px;
            left: 0;
        }

        .payment_wrap {
            width: calc(50% - 5px);
            height: 104px;
            padding: 12px;
            background: url("https://download.hecoos.com/enlightv/2025-10/5561b0592d9c549f9d9eaa18b50af912.png") no-repeat;
            background-size: 100% 100%;
            border-radius: 4px;

            .today_repay_amount {
                font-size: 18px;
                font-weight: 700;
                line-height: 26px;
                color: #5AB333;
                margin-top: 10px;
            }

            .text {
                font-size: 12px;
                line-height: 18px;
                color: #666666;
                margin-top: 2px;
            }
        }

        .invoice_wrap {
            width: calc(50% - 5px);
            height: 104px;
            padding: 12px;
            background: url("https://download.hecoos.com/enlightv/2025-10/ffd89b02d41e4fc88c8a719cac59613b.png") no-repeat;
            background-size: 100% 100%;
            border-radius: 4px;

            .today_invoice_amount {
                font-size: 18px;
                font-weight: 700;
                line-height: 26px;
                color: #F0AA32;
                margin-top: 10px;
            }

            .text {
                font-size: 12px;
                line-height: 18px;
                color: #666666;
                margin-top: 2px;
            }
        }

        .expire_goods_wrap {
            padding: 12px;

            .expire_goods_list {
                margin-top: 16px;

                .expire_goods_item {
                    padding: 10px 0;
                    border-bottom: 1px solid #E8E8E8;

                    .goods_names {
                        font-size: 12px;
                        font-weight: 700;
                        line-height: 18px;
                    }

                    .count {
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 18px;
                        color: #999999;
                    }

                    .order_text {
                        font-size: 12px;
                        line-height: 18px;
                        color: #666666;
                    }

                    .order_num {
                        font-size: 12px;
                        color: #2990FF;
                        line-height: 18px;
                    }

                    .max_expire_day {
                        font-size: 12px;
                        line-height: 18px;
                        color: #E44144;

                        &.today_expire {
                            color: #F0AA32;
                        }
                    }
                }
            }
        }
    }

    .add_btn {
        color: #666666;
    }
}
</style>
